import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { AvatarTypes } from '@mode/shared/contract-common';
import { LegacyRouterService } from '@mode/shared/util-js';

interface AvatarDetails {
  type: AvatarTypes.AvatarType;
  colorClass: string;
  initials: string;
  imageSrc: string;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[mode-context-dialog-workspace]',
  templateUrl: './context-dialog-workspace.component.html',
  styleUrls: ['./context-dialog-workspace.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextDialogWorkspaceComponent implements OnChanges {
  @Input() header = '';
  @Input() description = '';
  @Input() isCommunity = false;
  @Input() current = false;
  @Input() username?: string;
  @Input() connectDatabaseElementId?: string;
  @Input() avatar?: AvatarTypes.Avatars;
  public avatarDetails: AvatarDetails = {
    type: AvatarTypes.AvatarType.Initials,
    colorClass: '',
    initials: '',
    imageSrc: '',
  };
  public hovering = false;

  constructor(
    private _cdRef: ChangeDetectorRef,
    private _legacyRouterService: LegacyRouterService
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['avatar']) {
      const avatar = changes['avatar'].currentValue;
      this.avatarDetails = {
        type: avatar.type,
        colorClass: avatar?.colorClass ?? '',
        initials: avatar?.initials ?? '',
        imageSrc: avatar?.href ?? '',
      };
    }
  }

  @HostBinding('class')
  public get hostClass(): string {
    return this.hovering ? 'hovering' : '';
  }

  @HostListener('mouseenter')
  public mouseEnter(): void {
    this.hovering = true;
    this._cdRef.markForCheck();
  }

  @HostListener('mouseleave')
  public mouseLeave(): void {
    this.hovering = false;
    this._cdRef.markForCheck();
  }

  switchWorkspace(queryParams: boolean) {
    let url = `/home/${this.username}`;
    if (queryParams) {
      url += `?flow='context_switch'&trk_element_id=${this.connectDatabaseElementId}`;
    }
    this._legacyRouterService.navigateByUrl(url);
  }
}
